import { isObject } from 'lodash';
import { Link } from 'react-router-dom';
import { WarningMessage } from 'framework/ui/Message';
import { CandidateDuplicate } from 'domain/shared/candidate';
import { ADDITIONAL_CONTACTS_OPTIONS } from 'domain/shared/contact';
import ReportWrongDuplicateResultButton from './button/ReportWrongDuplicateResultButton';

const FIELD_LABELS: Dictionary<string> = {
  ...ADDITIONAL_CONTACTS_OPTIONS,
  personalPhoneNumber: 'Personal phone number',
  otherEmail: 'Other email address',
  personalEmail: 'Personal email address',
};

const getFieldLabels = (matches: Dictionary<number | Dictionary<number>>): string[] => {
  const labels: string[] = [];

  Object.entries(matches).forEach(([key, value]) => {
    if (isObject(value)) {
      labels.push(...getFieldLabels(value));
    }

    labels.push(value ? FIELD_LABELS[key] || '' : '');
  });

  return labels.filter(label => !!label);
};

const getMatchedFields = (matches: Dictionary<number | Dictionary<number>>) => {
  const labels = getFieldLabels(matches);

  return labels.length ? `(on ${labels.join(', ')}) ` : null;
};

const getCandidateData = (duplicate: CandidateDuplicate, openInNewTab: boolean) => {
  const firstName = duplicate.candidate.name.firstName || '';
  const middleName = duplicate.candidate.name.middleName || '';
  const lastName = duplicate.candidate.name.lastName || '';
  const maidenName = duplicate.candidate.name.maidenName ? `(${duplicate.candidate.name.maidenName})` : '';
  const duplicateId = duplicate.candidate.id ? `(id: ${duplicate.candidate.id})` : '';

  const name = `${firstName} ${middleName} ${lastName} ${maidenName} ${duplicateId} `;
  const target = openInNewTab ? '_blank' : '_self';

  return (
    <>
      <Link target={target} to={duplicate.url}>
        {name.replace(/  +/g, ' ')}
      </Link>
      <span style={{ marginLeft: 0.5 }}>{getMatchedFields(duplicate.score)}</span>
    </>
  );
};

const getWarningContent = (
  duplicates: Array<CandidateDuplicate>,
  openInNewTab: boolean,
  removeByCandidateIdFunc: (candidateId: any) => void,
) => {
  const isPlural = duplicates.length > 1;

  return (
    <>
      {duplicates.length} potential duplicate{isPlural ? 's have' : ' has'} been found:<span> </span>
      <ul style={{ paddingLeft: 15 }}>
        {duplicates.map(duplicate => (
          <li key={duplicate.candidate.id}>
            {getCandidateData(duplicate, openInNewTab)}
            <ReportWrongDuplicateResultButton duplicate={duplicate} removeByCandidateIdFunc={removeByCandidateIdFunc} />
          </li>
        ))}
      </ul>
    </>
  );
};

const getDuplicatesWarning = (
  duplicates: Array<CandidateDuplicate>,
  removeByCandidateIdFunc: (candidateId: any) => void,
  openInNewTab: boolean = false,
) => {
  if (duplicates.length === 0) {
    return null;
  }

  const content = getWarningContent(duplicates, openInNewTab, removeByCandidateIdFunc);

  return new WarningMessage(content);
};

export default getDuplicatesWarning;
